module.exports = __webpack_public_path__ + "img/delta@2x.1875182e.png";